import React, { Fragment } from 'react';
import { Button, Card, Col, Dropdown, Icon, Menu, Row, Tag } from 'antd';
import { convertArrayToObject, dateToString } from '../../../../utils';
import { PRODUCT_CONDITION } from '../../../../utils/const';

export default ({ product, showModal, gotoEdit }) => {

	const PRODUCT_CONDITION_OBJ = convertArrayToObject(PRODUCT_CONDITION, 'value', 'name');

	const InfoRow = ({ label, value }) => (
		<Row style={{ marginBottom: 8 }}>
			<Col span={10}>{label}</Col>
			<Col span={14}>: {value || '---'}</Col>
		</Row>
	);

	const menu = (<Menu>
		<Menu.Item>
			<a target="_blank" rel="noopener noreferrer" onClick={() => gotoEdit(product.id)}>
				Cập nhật thông tin
			</a>
		</Menu.Item>
		<Menu.Item>
			<a target="_blank" rel="noopener noreferrer" onClick={showModal}>
				Xoá sản phẩm
			</a>
		</Menu.Item>
	</Menu>);

	return <Fragment>
		<Card title={
			<div>
				<span>Thông tin sản phẩm</span>
				<div style={{ float: 'right' }}>
					<Dropdown overlay={menu}>
						<Button type="primary" style={{ marginRight: 10 }}>
							Thao tác <Icon type="down" />
						</Button>
					</Dropdown>
				</div>
			</div>
		}>
			<Row>
				<Col span={12}>
					{/*<InfoRow label="Tên sản phẩm" value={product.name} />*/}
					<InfoRow label="Mã đơn hàng" value={product.code} />
					{/*<InfoRow label="Mã barcode" value={product.barcode} />*/}
					<InfoRow label="Khối lượng" value={product.weight} />
					<InfoRow label="Đơn vị tính" value={product.unitName} />
					<InfoRow label="Phân loại" value={product.isNormal ? <Tag color="magenta">Sản phẩm thường</Tag> :
						<Tag color="green">Serial/IMEI</Tag>} />
					<InfoRow label="Tình trạng sử dụng" value={PRODUCT_CONDITION_OBJ[product.productCondition] || '---'} />
				</Col>
				<Col span={12}>
					<InfoRow label="Loại sản phẩm" value={product.productTypeResponse?.name || '---'} />
					<InfoRow label="Nhãn hiệu" value={product.brandResponse?.name || '---'} />
					{/*<InfoRow label="Tags" value="---" />*/}
					<InfoRow label="Ngày tạo" value={dateToString(product.createdDate)} />
					<InfoRow label="Ngày cập nhật cuối" value={dateToString(product.updatedDate)} />
				</Col>
			</Row>
			<Row>
				{!product?.isNormal && <Col span={24}>
					<div>
						<>Danh sách IMEI ({product?.imeiResponseList?.length || 0}): </>{product?.imeiResponseList?.map((el) =>
						<Tag key={el.id} color={'blue'} style={{ marginBottom: 10 }}>
							{el.imei}
						</Tag>)}
					</div>
				</Col>}
			</Row>
		</Card>
	</Fragment>;
}
